export const dateFormats = () => {
  return ["M/D/YY", "MM/DD/YY", "M/D/YYYY", "MM/DD/YYYY", "M-D-YYYY", "MM-DD-YYYY", "YYYY-M-D", "YYYY-MM-DD", "YYYY/M/D", "YYYY/MM/DD"];
};
